<template>
        <v-layout wrap>
            <v-flex lg4 sm4 py-6>
                <v-card class="mx-auto mr-6 ml-3 mr-sm-4 ml-sm-2"
                        min-height="110"
                        flat
                        @click="filtrarPorAtivos">
                    <div class="barra"/>
                    <v-list-item three-line class="mt-1">
                        <v-list-item-content>
                            <v-list-item-title class="text--darken-2 text-lg-h4 font-weight-bold grey--text headline mb-1">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        {{ quantidadeTotalAtivos }}
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        {{ valorTotalAtivos | valorParaDinheiro }}
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--darken-2 text-sm-body-2 font-weight-bold grey--text mb-1">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        ATIVOS
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        VALOR TOTAL
                                    </v-col>
                                </v-row>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-icon size="35" color="#BDBDBD">
                            far fa-check-circle
                        </v-icon>
                    </v-list-item>
                </v-card>
            </v-flex>

            <v-flex lg4 sm4 py-6>
                <v-card class="mx-auto mr-3 ml-3 mr-sm-2 ml-sm-2"
                        min-height="110"
                        flat
                        @click="filtrarPorEmElaboracao">
                    <div class="barra"/>
                    <v-list-item three-line class="mt-1">
                        <v-list-item-content>
                            <v-list-item-title class="text--darken-2 text-lg-h4 font-weight-bold grey--text headline mb-1">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        {{ quantidadeTotalEmElaboracao }}
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        {{ valorTotalEmElaboracao | valorParaDinheiro }}
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--darken-2 font-weight-bold grey--text text-sm-body-2 mb-1">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        EM ELABORAÇÃO
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        VALOR TOTAL
                                    </v-col>
                                </v-row>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-icon size="35" color="#BDBDBD">
                            far fa-edit
                        </v-icon>
                    </v-list-item>
                </v-card>
            </v-flex>

            <v-flex sm4 lg4 py-6>
                <v-card class="mx-auto mr-3 ml-6  mr-sm-1 ml-sm-4"
                        min-height="110"
                        flat
                        @click="filtrarPorBaixados">
                    <div class="barra"/>
                    <v-list-item three-line class="mt-1">
                        <v-list-item-content>
                            <v-list-item-title class="text--darken-2 text-lg-h4 font-weight-bold grey--text headline mb-1 ma-0 pa-0">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        {{ quantidadeTotalBaixados }}
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        {{ valorTotalBaixados | valorParaDinheiro }}
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--darken-2 font-weight-bold grey--text text-sm-body-2 mb-1 d-flex">
                                <v-row class="ma-0 pa-0">
                                    <v-col class="ma-0 pa-0" cols="5">
                                        BAIXADOS
                                    </v-col>
                                    <v-col class="ma-0 pa-0">
                                        VALOR TOTAL
                                    </v-col>
                                </v-row>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-icon size="35" color="#BDBDBD">
                            add_circle_outline
                        </v-icon>
                    </v-list-item>
                </v-card>
            </v-flex>
        </v-layout>
</template>

<script>
    export default {
        name: 'Totalizadores',
        props: ['totalizadores'],
        computed: {
            quantidadeTotalBaixados() {
                if (this.totalizadores.totalizadorPorOrgaoBaixados) {
                    return this.totalizadores.totalizadorPorOrgaoBaixados.quantidadeRegistros
                }
                return 0
            },
            valorTotalBaixados() {
                if (this.totalizadores.totalizadorPorOrgaoBaixados) {
                    return this.totalizadores.totalizadorPorOrgaoBaixados.valorTotal
                }
                return 0
            },
            quantidadeTotalEmElaboracao() {
                if (this.totalizadores.totalizadorPorOrgaoEmElaboracao) {
                    return this.totalizadores.totalizadorPorOrgaoEmElaboracao.quantidadeRegistros
                }
                return 0
            },
            valorTotalEmElaboracao() {
                if (this.totalizadores.totalizadorPorOrgaoEmElaboracao) {
                    return this.totalizadores.totalizadorPorOrgaoEmElaboracao.valorTotal
                }
                return 0
            },
            quantidadeTotalAtivos() {
                if (this.totalizadores.totalizadorPorOrgaoAtivos) {
                    return this.totalizadores.totalizadorPorOrgaoAtivos.quantidadeRegistros
                }
                return 0
            },
            valorTotalAtivos() {
                if (this.totalizadores.totalizadorPorOrgaoAtivos) {
                    return this.totalizadores.totalizadorPorOrgaoAtivos.valorTotal
                }
                return 0
            },
        },
        methods: {
            filtrarPorBaixados() {
                this.$emit('filtrarPatrimonioPorTotalizadores', 'Baixado')
            },
            filtrarPorEmElaboracao() {
                this.$emit('filtrarPatrimonioPorTotalizadores', 'Elaboração')
            },
            filtrarPorAtivos() {
                this.$emit('filtrarPatrimonioPorTotalizadores', 'Ativo')
            }
        }
    }
</script>

<style scoped lang="stylus">
    .barra
        background var(--v-primary-base)
        color var(--v-primary-base)
        height 5px
</style>
